import { Text } from '$components'
import { ReactNode } from 'react'

export type ModalHeadingProps = {
  children?: ReactNode,
  onClose?: () => void,
  className?: string,
}

export function ModalHeading({ children }: ModalHeadingProps) {

  return (
    <Text
      type="h2"
      as="h1"
    >
      { children }
    </Text>
  )
}
